import boswellIcon from '@/assets/boswell-icon.png';

export default function BoswellLogo({ className = 'h-8 w-8', showText = false, textClassName = '' }) {
  return (
    <div className="flex items-center gap-2">
      <img src={boswellIcon} alt="Boswell" className={className} />
      {showText && <span className={`text-xl font-bold ${textClassName}`}>Boswell</span>}
    </div>
  );
}
